export default "__VITE_ASSET__05342c7b__"